import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import Badge from "@mui/material/Badge";
import UserAvatarImgComponent from "../UserAvatarImgComponent"; 

import {
  MdMenuOpen,
  MdOutlineMenu,
  MdOutlineLightMode,
  MdNightlightRound,
} from "react-icons/md";
import { IoShieldHalfSharp, IoMenu } from "react-icons/io5";
import { FaRegBell } from "react-icons/fa6";
import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";

import PersonAdd from "@mui/icons-material/PersonAdd";
import Logout from "@mui/icons-material/Logout";

import { MyContext } from "../../App";
import { fetchDataFromApi, editData } from "../../utils/api";

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [newOrderNotification, setNewOrderNotification] = useState(null);
  const [hasLoadedInitialOrders, setHasLoadedInitialOrders] = useState(false);

  const prevOrdersRef = useRef([]);

  const openMyAcc = Boolean(anchorEl);
  const openNotifications = Boolean(notificationAnchorEl);

  const context = useContext(MyContext);
  const history = useNavigate();

  useEffect(() => {
    fetchDataFromApi(`/api/orders`).then((orders) => {
      prevOrdersRef.current = orders;
      context.setOrders(orders);
      setHasLoadedInitialOrders(true);
    });

    const interval = setInterval(() => {
      if (hasLoadedInitialOrders) {
        fetchOrdersAndNotify();
      }
    }, 10000);

    return () => clearInterval(interval);
  }, [hasLoadedInitialOrders]);

  const fetchOrdersAndNotify = () => {
    fetchDataFromApi(`/api/orders`).then((orders) => {
      const prevIds = new Set(prevOrdersRef.current.map((o) => o._id));
      const newOrders = orders.filter((o) => !prevIds.has(o._id));

      if (newOrders.length > 0) {
        setNewOrderNotification({ order: newOrders[0], visible: true });
        setTimeout(() => setNewOrderNotification(null), 10000);
      }

      prevOrdersRef.current = orders;
      context.setOrders(orders);
    });
  };

  const handleOpenMyAccDrop = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMyAccDrop = () => {
    setAnchorEl(null);
  };

  const handleOpenNotificationsDrop = (event) => {
    setNotificationAnchorEl(event.currentTarget);
  };

  const handleCloseNotificationsDrop = () => {
    setNotificationAnchorEl(null);
  };

  const changeTheme = () => {
    context.setTheme(context.theme === "dark" ? "light" : "dark");
  };

  const logout = () => {
    localStorage.clear();
    setAnchorEl(null);
    context.setAlertBox({
      open: true,
      error: false,
      msg: "Logout successful",
    });
    setTimeout(() => {
      history("/login");
    }, 2000);
  };

  const handleChangeStatus = (e, orderId) => {
    const newStatus = e.target.value;
    setIsLoading(true);
    context.setProgress(40);

    fetchDataFromApi(`/api/orders/${orderId}`).then((res) => {
      const order = {
        ...res,
        amount: parseInt(res.amount),
        status: newStatus,
      };

      editData(`/api/orders/${orderId}`, order).then(() => {
        fetchDataFromApi(`/api/orders`).then((res) => {
          context.setOrders(res);
          context.setProgress(100);
          setIsLoading(false);
        });
      });
    });
  };

  const pendingOrders = context.orders?.filter(
    (order) => order.status?.toLowerCase() === "pending"
  );

  return (
    <header className="d-flex align-items-center">
      <div className="container-fluid w-100">
        <div className="row d-flex align-items-center w-100">
          <div className="col-sm-2 part1 pr-0">
            <Link to={"/"} className="d-flex align-items-center logo">
              <img src={logo} alt="Logo" />
              <span className="ml-2">RISMIC</span>
            </Link>
          </div>

          {/* Sidebar toggle */}
          {context.windowWidth > 992 && (
            <div className="col-sm-3 d-flex align-items-center part2">
              <Button
                className="rounded-circle mr-3"
                onClick={() =>
                  context.setIsToggleSidebar(!context.isToggleSidebar)
                }
              >
                {context.isToggleSidebar ? <MdOutlineMenu /> : <MdMenuOpen />}
              </Button>
            </div>
          )}

          {/* Right Side Controls */}
          <div className="col-sm-7 d-flex align-items-center justify-content-end part3 position-relative">
            {/* Theme Toggle */}
            <Button className="rounded-circle mr-3" onClick={changeTheme}>
              {context.theme === "light" ? (
                <MdNightlightRound />
              ) : (
                <MdOutlineLightMode />
              )}
            </Button>

            {/* Notifications */}
            <div className="dropdownWrapper position-relative">
              <Button
                className="rounded-circle mr-3"
                onClick={handleOpenNotificationsDrop}
              >
                <Badge
                  color="error"
                  badgeContent={pendingOrders?.length || 0}
                  invisible={!pendingOrders || pendingOrders.length === 0}
                >
                  <FaRegBell />
                </Badge>
              </Button>

              {/* Mobile menu toggle */}
              {context.windowWidth < 992 && (
                <Button
                  className="rounded-circle mr-3"
                  onClick={() => context.openNav()}
                >
                  <IoMenu />
                </Button>
              )}

              {/* Notification Dropdown */}
              <Menu
                anchorEl={notificationAnchorEl}
                className="notifications dropdown_list"
                id="notifications"
                open={openNotifications}
                onClose={handleCloseNotificationsDrop}
                onClick={handleCloseNotificationsDrop}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}

              >
                <div className="px-3 pt-2">
                  <h4 className="mb-2">Pending Orders</h4>
                </div>
                <Divider className="mb-1" />

                <div
                  style={{ maxHeight: "300px", overflowY: "auto" }}
                  className="px-2"
                >
                  {pendingOrders?.length === 0 ? (
                    <p className="px-3 py-2 mb-0 text-muted small">
                      No pending orders
                    </p>
                  ) : (
                    pendingOrders.map((order) => (
                      <MenuItem
                        key={order._id}
                        className="d-block w-100 py-2"
                        divider
                        style={{ padding: "10px 16px" }}
                      >
                        <div className="d-flex justify-content-between align-items-start w-100">
                          {/* Left: Avatar + Info */}
                          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                            <UserAvatarImgComponent name={order.name} />

                            <div style={{ fontSize: "13px", color: "#333" }}>
                              <div style={{ fontWeight: "600", marginBottom: "4px" }}>
                                {order.name}
                              </div>
                              <div style={{ color: "#666" }}>
                                Amount: ₹{order.amount}
                              </div>
                            </div>
                          </div>
                         </div> 
                      </MenuItem>

                    ))
                  )}
                </div>


                <Divider />
                <div className="px-3 py-2">
                  <Link to="/delivery-persons/active">
                    <Button className="btn-blue w-100">View All Orders</Button>
                  </Link>
                </div>
              </Menu>
            </div>

            {/* New Order Popup Notification */}
            {newOrderNotification && newOrderNotification.visible && (
              <div
                style={{
                  position: "fixed",
                  top: "80px",
                  right: "20px",
                  backgroundColor: "#e6f4ea",
                  borderLeft: "6px solid #28a745",
                  padding: "20px 30px",
                  boxShadow: "0 8px 16px rgba(0,0,0,0.15)",
                  borderRadius: "6px",
                  zIndex: 1300,
                  minWidth: "320px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "20px",
                  color: "#155724",
                  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                  fontSize: "15px",
                  fontWeight: "600",
                  transition: "opacity 0.3s ease",
                }}
              >
                <div>
                  <div style={{ fontSize: "18px", marginBottom: "6px" }}>
                    New Order Received!
                  </div>
                  <div>Order # {newOrderNotification.order.name.slice(-6)}</div>
                  <div>Amount: ₹{newOrderNotification.order.amount}</div>
                </div>

                <div style={{ display: "flex", gap: "10px" }}>
                  <Button
                    variant="contained"
                    color="success"
                    size="small"
                    onClick={() =>
                      handleChangeStatus(
                        { target: { value: "confirm" } },
                        newOrderNotification.order._id
                      )
                    }
                    startIcon={<AiOutlineCheck />}
                    sx={{ fontWeight: "700" }}
                  >
                    Confirm
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    onClick={() =>
                      handleChangeStatus(
                        { target: { value: "cancelled" } },
                        newOrderNotification.order._id
                      )
                    }
                    startIcon={<AiOutlineClose />}
                    sx={{ fontWeight: "700" }}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            )}


            {/* Auth Section */}
            {context.isLogin !== true ? (
              <Link to={"/login"}>
                <Button className="btn-blue btn-lg btn-round">Sign In</Button>
              </Link>
            ) : (
              <div className="myAccWrapper">
                <Button
                  className="myAcc d-flex align-items-center"
                  onClick={handleOpenMyAccDrop}
                >
                  <div className="userImg">
                    <span className="rounded-circle">
                      {context.user?.name?.charAt(0)}
                    </span>
                  </div>
                  <div className="userInfo res-hide">
                    <h4>{context.user?.name}</h4>
                    <p className="mb-0">{context.user?.email}</p>
                  </div>
                </Button>

                <Menu
                  anchorEl={anchorEl}
                  id="account-menu"
                  open={openMyAcc}
                  onClose={handleCloseMyAccDrop}
                  onClick={handleCloseMyAccDrop}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                >
                  <MenuItem onClick={handleCloseMyAccDrop}>
                    <Link
                      to="/my-account"
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      <ListItemIcon>
                        <PersonAdd fontSize="small" />
                      </ListItemIcon>
                      My Account
                    </Link>
                  </MenuItem>
                  <MenuItem onClick={handleCloseMyAccDrop}>
                    <ListItemIcon>
                      <IoShieldHalfSharp />
                    </ListItemIcon>
                    Reset Password
                  </MenuItem>
                  <MenuItem onClick={logout}>
                    <ListItemIcon>
                      <Logout fontSize="small" />
                    </ListItemIcon>
                    Logout
                  </MenuItem>
                </Menu>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};



export default Header;
